import PlanPermission from 'container/PlanPermission';

import BuilderModePropertyTableMetadataView from './BuilderModePropertyTableMetadataView';

export default PlanPermission(BuilderModePropertyTableMetadataView);
